// custom-cart-guard.js（ドロワーを使わない最終版）
(function () {
  // ---------- Utils ----------
  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }
  async function setCartTemp(temp) {
    const fd = new FormData();
    fd.append('attributes[cart_temp]', temp);
    await fetch('/cart/update.js', { method: 'POST', body: fd, credentials: 'same-origin' });
  }
  function findProductTemp() {
    const holder = document.querySelector('#product-temp');
    return holder ? holder.dataset.temp || '' : '';
  }

  // ---------- 上部フォールバック帯 ----------
  function showTopErrorBanner(msg) {
    let bar = document.querySelector('.cart-error-banner');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'cart-error-banner';
      document.body.prepend(bar);
    }
    bar.textContent = msg;
    clearTimeout(bar._t);
    bar._t = setTimeout(() => { bar.remove(); }, 12000);

    if (!document.getElementById('cart-error-style')) {
      const style = document.createElement('style');
      style.id = 'cart-error-style';
      style.textContent = `
        .cart-error-banner{
          background:#ffe9e9;color:#b00020;border:1px solid #f5b5b5;
          padding:10px 12px;font-size:14px;line-height:1.6
        }`;
      document.head.appendChild(style);
    }
  }

  // ---------- ボタン直上に強調エラー ----------
  function showInlineError(form, msg) {
    const submitBtn = form.querySelector('button[type="submit"], button[name="add"], [data-add-to-cart]');
    const anchorEl  = submitBtn || form;

    let inline = form.querySelector('.cart-inline-error');
    if (!inline) {
      inline = document.createElement('div');
      inline.className = 'cart-inline-error';
      anchorEl.parentNode.insertBefore(inline, anchorEl); // ボタン直前に挿入
    }
    inline.innerHTML = `⚠︎ <strong>同時購入できません。：</strong> ${msg}`;

    if (!document.getElementById('cart-inline-error-style')) {
      const style = document.createElement('style');
      style.id = 'cart-inline-error-style';
      style.textContent = `
        .cart-inline-error{
          background:#fff3f3;color:#b00020;border:1px solid #f5b5b5;
          padding:12px 14px;border-radius:8px;margin:0 0 10px;
          font-size:15px;line-height:1.7;box-shadow:0 1px 0 rgba(0,0,0,.03)
        }
        .cart-inline-error.animate{animation:cartShake .25s linear 2}
        @keyframes cartShake{
          0%{transform:translateX(0)}25%{transform:translateX(-4px)}
          50%{transform:translateX(4px)}75%{transform:translateX(-2px)}
          100%{transform:translateX(0)}
        }`;
      document.head.appendChild(style);
    }

    inline.classList.remove('animate'); inline.offsetHeight; inline.classList.add('animate');
    inline.scrollIntoView({ behavior: 'smooth', block: 'center' });

    clearTimeout(inline._t);
    inline._t = setTimeout(() => inline.remove(), 12000);
    form.addEventListener('change', () => inline && inline.remove(), { once:true });

    // 念のため上部帯も出す
    showTopErrorBanner(msg);
  }

  // ---------- 追加（AJAX固定、成功時は /cart へ） ----------
  async function ajaxAdd(form) {
    const fd = new FormData(form);
    const res = await fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' });
    const data = await res.json().catch(() => ({}));

    if (!res.ok || data.status === 422) {
      showInlineError(form, data.description || '追加できませんでした。');
      return false;
    }
    location.href = '/cart';
    return true;
  }

  // --------- 本体：同期POSTを止めて必ずAJAXに ----------
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action^="/cart/add"]')) return;

    e.preventDefault();

    const incomingTemp = findProductTemp();
    try {
      if (incomingTemp) {
        const cart = await getCart();
        const currentTemp = (cart.attributes && cart.attributes.cart_temp) || '';
        if (!currentTemp) {
          await setCartTemp(incomingTemp);
        } else if (currentTemp !== incomingTemp) {
          const jp = (t) => (t === 'reizou' ? '冷蔵' : '冷凍');
          showInlineError(
            form,
            `現在のカートは「${jp(currentTemp)}」です。「${jp(incomingTemp)}」商品は配送方法が異なるため同時に購入できません。カート内容をご確認ください。`
          );
          return;
        }
      }
      await ajaxAdd(form);
    } catch (err) {
      console.error(err);
      showInlineError(form, '通信エラーが発生しました。');
    }
  }, true);
})();